import getWebShellClientLocale from "../../../../utils/get-webshellclient-locale";
import makeQueryKey from "../../../../utils/make-query-key";
var getPartnerCartReviewsQueryKey = function getPartnerCartReviewsQueryKey() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      isPromosUpdating: false
    },
    isPromosUpdating = _ref.isPromosUpdating;
  var country = getWebShellClientLocale().country;
  return makeQueryKey(['buy/partner_cart_reviews/v2', {
    country: country,
    isPromosUpdating: isPromosUpdating
  }]);
};
export default getPartnerCartReviewsQueryKey;